import React from 'react';
import { useQuery } from '@tanstack/react-query';

import type { EmployerDetail, UseQueryWrapper } from 'app/types';

import { useSnakeBar } from 'app/hooks/useSnakeBar';
import { employerService } from 'app/Domain/Employers/Services/EmployerService';

export type GetEmployerDetailQueryResultData = EmployerDetail;

export type GetEmployerDetailQueryVariables = {
  employerId: string | undefined;
};

const queryFn =
  ({ employerId }: GetEmployerDetailQueryVariables) =>
  async (): Promise<GetEmployerDetailQueryResultData> => {
    const response = await employerService.getEmployerDetail(employerId!);
    return response.data as EmployerDetail;
  };

const QUERY_KEY = 'getEmployerDetail';

export const useEmployerGetDetailQuery: UseQueryWrapper<
  GetEmployerDetailQueryResultData,
  GetEmployerDetailQueryVariables
> = ({ variables, options }) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  return useQuery<GetEmployerDetailQueryResultData>([QUERY_KEY, variables.employerId], queryFn(variables), {
    onError,
    enabled: !!variables.employerId,
    ...(options || {}),
  });
};
